import { Component, Input } from '@angular/core';
import { NgbActiveModal }  from '@ng-bootstrap/ng-bootstrap';

import { CustomerModel }       from './models/customer';
import { StreamSearchService } from '../api/stream-search.service';

@Component({
  selector   : 'wor-customer-change',
  template: require('./customer-change.component.html')
})
export class CustomerChangeComponent {
  @Input() customer: CustomerModel;

  searchList: Array<any> = [];
  selected: any = null;

  constructor (
    public activeModal: NgbActiveModal,
    private streamSearchService: StreamSearchService
  ) {}

  formatCustomer (customer: any): string {
    return customer ? customer.display_name : '';
  }

  searchCustomers (typed: string): Promise<any> {
    return this.streamSearchService.search('customers', typed)
      .then((customers: Array<any>) => this.searchList.concat(customers));
  }

  chooseCustomer (customer: any): void {
    this.selected = customer;
  }

  confirm (): void {
    this.activeModal.close(this.selected);
  }
}
